import { API_BASE_URL } from '../constants/index';
import fetchService from './fetch.service';

function createLog(log, stopId) {
  const requestOptions = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ log, stopId }),
  };
  const url = `${API_BASE_URL}logs`;
  return fetchService.getFetchData(url, requestOptions);
}

const logService = {
  createLog,
};
export default logService;
